import PropTypes from 'prop-types';
import React from 'react';
import { ExpandableContainer } from '@unite-us/app-components';
import ClientNeedEditForm from 'common/display/SingleItemDetails/ClientNeedEditForm';
import ModalEditForm from '../../../modal/ModalEditForm';
import addLineBreaks from '../../../utils/addLineBreaks';

function AssociatedNeedsSection({
  clientNeeds,
  editable,
  needIds,
  personId,
  referral,
  selectedNeeds,
  show,
  submit,
  onUpdate,
}) {
  if (!show) {
    return null;
  }

  return (
    <div className="row detail-info__client-need-container">
      <div className="col-md-10">
        <div className="detail-info__client-need">
          <ExpandableContainer
            id="detail-description-expandable"
            header="Associated needs"
            collapsedHeight="70px"
          >
            <p className="no-margin">{addLineBreaks(selectedNeeds)}</p>
          </ExpandableContainer>
        </div>
      </div>
      <div className="col-md-2">
        <ModalEditForm
          id="edit-client-need-modal"
          buttonId="edit-client-need"
          header="Edit Associated Needs"
          size="large"
          showEdit={editable}
          labelText="Edit"
        >
          <ClientNeedEditForm
            needIds={needIds}
            clientNeeds={clientNeeds}
            submit={submit}
            referral={referral}
            onUpdate={onUpdate}
            personId={personId}
          />
        </ModalEditForm>
      </div>
    </div>
  );
}

AssociatedNeedsSection.propTypes = {
  clientNeeds: PropTypes.array.isRequired,
  editable: PropTypes.bool.isRequired,
  needIds: PropTypes.array.isRequired,
  personId: PropTypes.string,
  referral: PropTypes.object,
  selectedNeeds: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

AssociatedNeedsSection.defaultProps = {
  personId: undefined,
  referral: null,
};

export default AssociatedNeedsSection;
